import styled from 'styled-components';
import { mobile } from '../../../utils/breakpoints';

export const Image = styled.img`
  margin-left: -50px;

  @media(max-width: ${mobile.max}px) {
    margin-left: -20px;
    height: 60px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/title-image/styles/title-image.style.js